// extracted by mini-css-extract-plugin
module.exports = {"MerchantFullCalendar":"MerchantWidgetCalendar_MerchantFullCalendar__kxcCb","MerchantFullCalendar__Calendar":"MerchantWidgetCalendar_MerchantFullCalendar__Calendar__Ck3FI"};